// limpeza / conversão de campos
function configUtil() {

	function remove_extra(str) {
		str = str.replace(/\./g,'');
		str = str.replace(/\-/g,'');
		str = str.replace(/\//g,'');
		str = str.replace(/\(/g,'');
		str = str.replace(/\)/g,'');
		return str;
	}

	function format_num(num) {
		num += ''; //transforma para string
		num = num.replace(/\,/g,'.');
		num = parseFloat(num);

		if(isNaN(num)) {
			return;
		}

		return num.toFixed(2).replace(/\./g,',');
	}

	function to_num(num) {
		num += '';
		num = num.replace(/\,/g,'.');
		num = parseFloat(num);

		return num;
	}

}

export default configUtil
